import React, { useEffect } from 'react';

import BusinessIcon from '@mui/icons-material/Business';
import { Box, Container, Grid } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import {
    CollapsedBreadcrumbs,
    HeaderContainer,
    TitleIcon,
    TabsSystem,
} from 'common/components';

import companyGeneral from '../companyGeneral';
import * as companyGeneralActions from '../companyGeneral/actions';
import * as companyGeneralSelectors from '../companyGeneral/selectors';
import companyUsers from '../companyUsers';

const getTabs = (t) => [
    {
        id: 'company',
        label: t('Company', { count: 2 }),
        content: <companyGeneral.Container />,
    },
    {
        id: 'users',
        label: t('User', { count: 2 }),
        content: <companyUsers.Container />,
    },
];

const CompanyContainer = ({
    companyDetail,
    fetchCompanyDetail,
    isFetchingCompanyDetail,
    match,
    redirect,
}) => {
    const { t } = useTranslation();
    useEffect(() => {
        if (match.params.id) {
            fetchCompanyDetail(match.params.id);
        }
    }, [match.params.id]);

    if (isFetchingCompanyDetail) return null;

    return (
        <Container maxWidth={false}>
            <HeaderContainer sxHeader={{ px: 2 }}>
                <Grid size={18}>
                    <TitleIcon
                        icon={<BusinessIcon />}
                        title={t('Company file')}
                    />
                </Grid>

                <Box>
                    <CollapsedBreadcrumbs
                        current={companyDetail?.name}
                        locations={[
                            {
                                label: t('Company', { count: 2 }),
                                action: () => redirect('/companies'),
                            },
                        ]}
                    />
                </Box>
            </HeaderContainer>

            <TabsSystem
                baseUrl={`company-file/${match.params.id}`}
                tabs={getTabs(t)}
            />
        </Container>
    );
};

CompanyContainer.propTypes = {
    companyDetail: PropTypes.object,
    fetchCompanyDetail: PropTypes.func,
    isFetchingCompanyDetail: PropTypes.bool,
    match: PropTypes.object,
    redirect: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    companyDetail: companyGeneralSelectors.getCompanyDetailData,
    isFetchingCompanyDetail: companyGeneralSelectors.getIsFetchingCompanyDetail,
});

const mapDispatchToProps = (dispatch) => ({
    fetchCompanyDetail: (id) =>
        dispatch(companyGeneralActions.fetchCompanyDetail(id)),
    redirect: (link) => dispatch(push(link)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(CompanyContainer));
